import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

import { Observable } from 'rxjs';
import { takeWhile, tap } from 'rxjs/operators';

import { select, Store } from '@ngrx/store';

import { District } from '../models';
import * as fromStore from '../store';

@Component({
	selector: 'opus-district-rental-returns-editor',
	templateUrl: './district-rental-returns-editor.component.html',
})
export class DistrictRentalReturnsEditorComponent {
	alive = true;
  district$: Observable<District>;
  district: District;
	panelState$: Observable<fromStore.PanelState>;
	panelState: fromStore.PanelState;
	editor: FormGroup;
	months: string[] = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	days: { [id: string]: string[] } = {};
	blackoutStart: Date;
	blackoutEnd: Date;

  constructor(private store: Store<fromStore.DistrictsState>, private fb: FormBuilder) {
    console.log('DistrictRentalReturnsEditorComponent()...');
	}

	ngOnInit() {
    console.log('DistrictRentalReturnsEditorComponent.ngOnInit()...');

    this.district$ = this.store.pipe(select(fromStore.getDetailsStateDistrict));
    this.district$.pipe(
			takeWhile(() => this.alive)
    ).subscribe(s => this.district = s);

		this.panelState$ = this.store.pipe(select(fromStore.getDetailsStateRentalReturnsPanel));
		this.panelState$.pipe(
			takeWhile(() => this.alive),
			tap(s => {
				if (!s.editing && this.panelState && this.panelState.editing) {
          console.log('DistrictRentalReturnsEditorComponent.panelState$: clearing form...');
					this.resetForm();
				}
			}),
		).subscribe(s => this.panelState = s);

		this.createForm();
	}

	ngOnDestroy() {
    console.log('DistrictRentalReturnsEditorComponent.ngOnDestroy()...');
		this.alive = false;
	}

	createForm() {
    this.blackoutStart = this.district.blackoutStart
      ? new Date(Date.parse(this.district.blackoutStart))
			: new Date(9999, 0, 1);
    this.blackoutEnd = this.district.blackoutEnd
      ? new Date(Date.parse(this.district.blackoutEnd))
			: new Date(9999, 0, 1);

		this.editor = this.fb.group({
      inheritRentalReturns: [this.inheritRentalReturns],
			hasBlackoutPeriod: [this.hasBlackoutPeriod],
			blackoutStartMonth: [this.blackoutStart.getMonth()],
			blackoutStartDay: [this.blackoutStart.getDate()],
			blackoutEndMonth: [this.blackoutEnd.getMonth()],
			blackoutEndDay: [this.blackoutEnd.getDate()],
		});

		this.initMonthChanges();
	}

	resetForm() {
		this.editor.reset({
      inheritRentalReturns: this.inheritRentalReturns,
			hasBlackoutPeriod: this.hasBlackoutPeriod,
			blackoutStartMonth: this.blackoutStart.getMonth(),
			blackoutStartDay: this.blackoutStart.getDate(),
			blackoutEndMonth: this.blackoutEnd.getMonth(),
			blackoutEndDay: this.blackoutEnd.getDate(),
		});
	}

	initMonthChanges() {
		const keys: string[] = ['blackoutStart', 'blackoutEnd'];

		for (const key of keys) {
			this.days[this[key].getMonth()] = this.getDaysInMonth(this[key].getMonth());

			this.editor.get(key + 'Month').valueChanges.pipe(
				takeWhile(() => this.alive),
			).subscribe(val => {
				console.log(key + 'Month.valueChanges: ', val);

				if (!this.days[val]) {
					this.days[val] = this.getDaysInMonth(val);
				}

				const ctrl = this.editor.get(key + 'Day');
				const lastDay = this.days[val][this.days[val].length - 1];

				if (+ctrl.value > +lastDay) {
					ctrl.setValue(lastDay, { emitEvent: false });
				}
			});
		}
	}

	getDaysInMonth(month) {
		const days: string[] = [];

		for (let i = 1; i <= new Date(9999, +month + 1, 0).getDate(); i++) {
			days.push(i.toString());
		}

		return days;
	}

	get canSave(): boolean {
		return this.editor.valid && this.editor.dirty;
	}

	get saveButtonLabel(): string {
		return this.panelState.updating ? 'Saving...' : 'Save';
	}

  get inheritRentalReturns() {
    return this.district.inheritRentalReturns ? 'Yes' : 'No';
	}

	get hasBlackoutPeriod() {
    return this.district.hasBlackoutPeriod ? 'Yes' : 'No';
	}

	onSubmit() {
		console.log('onSubmit: ', this.editor.status, this.editor.value);

    const inheritRentalReturns = this.editor.value.inheritRentalReturns == 'Yes';
		const hasBlackOutPeriod = this.editor.value.hasBlackoutPeriod == 'Yes';
    const blackoutStart = hasBlackOutPeriod ? `${+this.editor.value.blackoutStartMonth + 1}/${this.editor.value.blackoutStartDay}/9999` : this.district.blackoutStart;
    const blackoutEnd = hasBlackOutPeriod ? `${+this.editor.value.blackoutEndMonth + 1}/${this.editor.value.blackoutEndDay}/9999` : this.district.blackoutEnd;

    const district = {
      ...this.district,
      inheritRentalReturns: this.editor.value.inheritRentalReturns == 'Yes',
			hasBlackoutPeriod: this.editor.value.hasBlackoutPeriod == 'Yes',
			blackoutStart,
			blackoutEnd,
		};

    this.store.dispatch(new fromStore.UpdateDistrictPanel({ panel: fromStore.PanelId.RentalReturns, district }));
	}
}
